"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingsHandler2 = require("./SettingsHandler");

var _SettingsHandler3 = _interopRequireDefault(_SettingsHandler2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Dev note: This whole class exists in the event someone logs out and back in - we want
// to make sure the right MatrixClient is listening for changes.

/**
 * Represents the base class for settings handlers which need access to a MatrixClient.
 * This class performs no logic and should be overridden.
 */
var MatrixClientBackedSettingsHandler = function (_SettingsHandler) {
    (0, _inherits3.default)(MatrixClientBackedSettingsHandler, _SettingsHandler);
    (0, _createClass3.default)(MatrixClientBackedSettingsHandler, null, [{
        key: "matrixClient",
        set: function set(client) {
            var oldClient = MatrixClientBackedSettingsHandler._matrixClient;
            MatrixClientBackedSettingsHandler._matrixClient = client;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(MatrixClientBackedSettingsHandler._instances), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var instance = _step.value;

                    instance.initMatrixClient(oldClient, client);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }]);

    function MatrixClientBackedSettingsHandler() {
        (0, _classCallCheck3.default)(this, MatrixClientBackedSettingsHandler);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MatrixClientBackedSettingsHandler.__proto__ || (0, _getPrototypeOf2.default)(MatrixClientBackedSettingsHandler)).call(this));

        MatrixClientBackedSettingsHandler._instances.push(_this);
        return _this;
    }

    (0, _createClass3.default)(MatrixClientBackedSettingsHandler, [{
        key: "initMatrixClient",
        value: function initMatrixClient() {
            console.warn("initMatrixClient not overridden");
        }
    }]);
    return MatrixClientBackedSettingsHandler;
}(_SettingsHandler3.default); /*
                              Copyright 2019 New Vector Ltd.
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

MatrixClientBackedSettingsHandler._instances = [];
exports.default = MatrixClientBackedSettingsHandler;
module.exports = exports["default"];
//# sourceMappingURL=MatrixClientBackedSettingsHandler.js.map